import React from "react";
import ReactDOM from "react-dom";
import "./styles/app.css";
import "../node_modules/fullcalendar-reactwrapper/dist/css/fullcalendar.min.css";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import reducers from "./reducers";
import history from "./routes/history";
import serviceWorker from "./serviceWorker";

import Main from "./Main";

const middlewares = [thunk, routerMiddleware(history)];

ReactDOM.render(
  <Provider
    store={createStore(
      connectRouter(history)(reducers),
      {},
      applyMiddleware(...middlewares)
    )}
  >
    <Main />
  </Provider>,
  document.getElementById("root")
);
serviceWorker.initialConfigNotification();



// WEBPACK FOOTER //
// ./src/index.js